// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__KSiqR","notes":"Notes_notes__2u6Qm"};